export var SensorVendors;
(function (SensorVendors) {
    SensorVendors["energybox"] = "Energybox";
    SensorVendors["monnit"] = "G-Hub";
    SensorVendors["UNASSIGNED"] = "";
})(SensorVendors || (SensorVendors = {}));
export var SensorOnlineState;
(function (SensorOnlineState) {
    SensorOnlineState["ACTIVE"] = "ACTIVE";
    SensorOnlineState["INACTIVE"] = "INACTIVE";
})(SensorOnlineState || (SensorOnlineState = {}));
export var SensorType;
(function (SensorType) {
    SensorType["TEMPERATURE"] = "TEMPERATURE";
    SensorType["HUMIDITY"] = "HUMIDITY";
    SensorType["BINARY"] = "BINARY";
})(SensorType || (SensorType = {}));
export var SensorTypesText;
(function (SensorTypesText) {
    SensorTypesText["TEMPERATURE"] = "Temperature";
    SensorTypesText["HUMIDITY"] = "Humidity";
    SensorTypesText["BINARY"] = "Binary";
})(SensorTypesText || (SensorTypesText = {}));
export var SensorTarget;
(function (SensorTarget) {
    SensorTarget["SPACE"] = "SPACE";
    SensorTarget["EQUIPMENT"] = "EQUIPMENT";
})(SensorTarget || (SensorTarget = {}));
export var SensorParentResourceType;
(function (SensorParentResourceType) {
    SensorParentResourceType["SPACE"] = "Space";
    SensorParentResourceType["EQUIPMENT"] = "Equipment";
})(SensorParentResourceType || (SensorParentResourceType = {}));
export const SensorIntervals = [
    { label: '1 min', value: 60000 },
    { label: '2 mins', value: 120000 },
    { label: '3 mins', value: 180000 },
    { label: '4 mins', value: 240000 },
    { label: '5 mins', value: 300000 },
    { label: '6 mins', value: 360000 },
    { label: '7 mins', value: 420000 },
    { label: '8 mins', value: 480000 },
    { label: '9 mins', value: 540000 },
    { label: '10 mins', value: 600000 },
    { label: '15 mins', value: 900000 },
    { label: '20 mins', value: 1200000 },
    { label: '30 mins', value: 1800000 },
];
export var SensorTypeFromApi;
(function (SensorTypeFromApi) {
    SensorTypeFromApi["TEMPERATURE"] = "temperature";
    SensorTypeFromApi["HUMIDITY"] = "humidity";
    SensorTypeFromApi["STATE"] = "state";
})(SensorTypeFromApi || (SensorTypeFromApi = {}));
export const BinaryReadingLabel = {
    true: 'Open',
    false: 'Closed',
};
export var ActivePowerSensorType;
(function (ActivePowerSensorType) {
    ActivePowerSensorType["ACTIVE_POWER"] = "ACTIVE_POWER";
})(ActivePowerSensorType || (ActivePowerSensorType = {}));
